'use client';

import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/src/hooks/useAuth';

export function PublicLayout() {
  const { isAuth, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-dvh">
        <div className="animate-pulse text-muted-foreground">Carregando...</div>
      </div>
    );
  }
  if (isAuth && location.pathname === '/login') {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <div className="flex min-h-dvh flex-col bg-white">
      <main className="flex flex-1 p-0">
        <div className="flex-1 p-6 text-[#1D1617]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
